var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"f38eb92b30cdcfc0107e8b8a127bf6b091fac7a2"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["javascript-react@farmec-sa"]={id:"f38eb92b30cdcfc0107e8b8a127bf6b091fac7a2"};
      